import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import moment from 'moment-timezone';

import { money } from '@/core/money';
import { darkGreen } from '@/theme/colors';

interface StripeReceipt {
  id: string;
  amount: number;
  currency: string;
  created_at: string;
  description: string | null;
  receipt_url: string | null;
  status: string;
}

interface StripeReceiptListProps {
  receipts: StripeReceipt[];
}

export function StripeReceiptList({ receipts }: StripeReceiptListProps): JSX.Element {
  if (receipts.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary" sx={{ py: 2 }}>
        No payment receipts yet.
      </Typography>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell style={{ textTransform: 'none', width: '100px' }}>Date</TableCell>
          <TableCell style={{ textTransform: 'none' }}>Description</TableCell>
          <TableCell style={{ textTransform: 'none', width: '100px', textAlign: 'right' }}>
            Amount
          </TableCell>
          <TableCell style={{ textTransform: 'none', width: '100px', textAlign: 'center' }}>
            Receipt
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {receipts.map((receipt) => (
          <TableRow key={receipt.id}>
            <TableCell style={{ width: '100px' }}>
              {moment(receipt.created_at).format('DD MMM YYYY')}
            </TableCell>
            <TableCell>{receipt.description || '\u2014'}</TableCell>
            <TableCell style={{ textAlign: 'right', width: '100px' }}>
              {money({
                cents: receipt.amount,
                currency: receipt.currency.toUpperCase(),
              }).formatted()}
            </TableCell>
            <TableCell style={{ textAlign: 'center', width: '100px' }}>
              {receipt.receipt_url ? (
                <a
                  href={receipt.receipt_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: darkGreen, textDecoration: 'none' }}
                >
                  View Receipt
                </a>
              ) : (
                '\u2014'
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default StripeReceiptList;
